import type { IErrorCard } from '@/shared/common/types/cardError.type';

/** Sujeto genérico, para cuando el backend rechaza sin exponer de quién se trata. */
const BLACKLISTED_ASSIGNEE_FALLBACK_SUBJECT = 'este usuario';

/**
 * Plantilla única del copy de lista negra (BL).
 * `selected-info` la interpola con el nombre del destinatario rechazado; las fallas
 * de POST/PATCH no lo conocen y caen al sujeto genérico.
 *
 * @param destinatary - Nombre del usuario rechazado.
 */
export function getBlacklistedAssigneeMessage(
  destinatary: string = BLACKLISTED_ASSIGNEE_FALLBACK_SUBJECT
): string {
  return `No puedes continuar con la creación de la tarjeta para ${destinatary}. (BL)`;
}

export const ErrorsCard: IErrorCard = {
  INTERNAL_BLACK_LISTED_PERSON: 'Ocurrió un error al crear tu tarjeta (BL)',
  PARTNER_BLACK_LISTED_PERSON: 'Ocurrió un error al crear tu tarjeta (BL)',
  CUSTOMER_ACCOUNT_NEED_ATTENTION: getBlacklistedAssigneeMessage(),
} as const;
